import { msgs } from "../define";

/** Shared dialog chrome (unsaved-changes prompt) and the sectioned service / product form. */
export const ui = msgs({
  en: {
    "ui.discard.title": "Discard changes?",
    "ui.discard.body": "You have unsaved changes. If you close now, they will be lost.",
    "ui.discard.confirm": "Discard",
    "ui.discard.keep": "Keep editing",
    "svc.sec.basics": "Basics",
    "svc.sec.pricing": "Pricing",
    "svc.sec.variants": "Variants",
    "svc.sec.booking": "Booking & deposit",
    "svc.sec.staff": "{staff}",
    "svc.sec.stock": "Stock & codes",
    "svc.var.name": "Name",
    "svc.var.price": "Price",
    "svc.var.duration": "Duration (min)",
    "svc.var.cost": "Cost",
    "svc.var.none": "No variants — one price for everyone.",
  },
  zh: {
    "ui.discard.title": "放弃修改？",
    "ui.discard.body": "有尚未保存的修改，现在关闭将会丢失。",
    "ui.discard.confirm": "放弃",
    "ui.discard.keep": "继续编辑",
    "svc.sec.basics": "基本信息",
    "svc.sec.pricing": "价格",
    "svc.sec.variants": "规格",
    "svc.sec.booking": "预约与定金",
    "svc.sec.staff": "{staff}",
    "svc.sec.stock": "库存与编码",
    "svc.var.name": "名称",
    "svc.var.price": "价格",
    "svc.var.duration": "时长（分钟）",
    "svc.var.cost": "成本",
    "svc.var.none": "暂无规格——所有人同一价格。",
  },
  ms: {
    "ui.discard.title": "Buang perubahan?",
    "ui.discard.body": "Ada perubahan yang belum disimpan. Jika ditutup sekarang, ia akan hilang.",
    "ui.discard.confirm": "Buang",
    "ui.discard.keep": "Terus edit",
    "svc.sec.basics": "Asas",
    "svc.sec.pricing": "Harga",
    "svc.sec.variants": "Varian",
    "svc.sec.booking": "Tempahan & deposit",
    "svc.sec.staff": "{staff}",
    "svc.sec.stock": "Stok & kod",
    "svc.var.name": "Nama",
    "svc.var.price": "Harga",
    "svc.var.duration": "Tempoh (min)",
    "svc.var.cost": "Kos",
    "svc.var.none": "Tiada varian — satu harga untuk semua.",
  },
});
